import { AbstractControl } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";

const today = new Date();
today.setHours(0, 0, 0, 0);     // Rimuovo il tempo dall'oggetto Date per confrontare solo le date

const startDate = new Date(today.setDate(today.getDate()+30))

const startDate2 = new Date(today.setDate(today.getDate()+31))


const filterDate = (d: Date | null): boolean => {
    return d !== null && d > startDate;
}

const filterDate2 = (d: Date | null): boolean => {
    return d !== null && d > startDate2;
}


export const RichiestaOccupazioneStep: FormlyFieldConfig[] =
  [
    {
      "key": 'jd.oggetto',
      "type":'mat-textarea',
      "props": {
        "label": "MOTIVAZIONE DELLA RICHIESTA",
        "required": true,
        "autosize":true,
        "autosizeMaxRows":8,
        "autosizeMinRows": 2
      },
    },
    {
      "fieldGroup":[

        {
          "fieldGroupClassName":
            'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-3 gap-4',
          "fieldGroup": [
                        {
                            "className": 'sm:col-span-1 md:col-span-1',
                            "key": 'jd.autorizzata_dal',
                            "type": "#data",
                            "props": {
                                "label": 'DATA INIZIO',
                                "datepickerOptions": {
                                    "startAt": startDate,
                                    "filter": filterDate
                                },
                            },
                            validators: {
                              datemin: {
                                expression: (c: AbstractControl) => {
                                  if (!c.value) return true; // se vuoto, lascia passare (delegato ad altri validator es. required)
                                  const inputDate = new Date(c.value);
                                  return !isNaN(inputDate.getTime()) && inputDate > startDate;
                                },
                                message: (error: any, field: FormlyFieldConfig) =>
                                  `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                              },
                            }
                        },
                        {
                            "className": 'sm:col-span-1 md:col-span-1',
                            "key": 'jd.autorizzata_al',
                            "type": "#data",
                            "props": {
                                "label": 'DATA FINE',
                                "datepickerOptions": {
                                    "startAt": startDate,
                                    "filter": filterDate
                                },
                            },
                            validators: {
                              datemin: {
                                expression: (c: AbstractControl) => {
                                  if (!c.value) return true; // se vuoto, lascia passare (delegato ad altri validator es. required)
                                  const inputDate = new Date(c.value);
                                  return !isNaN(inputDate.getTime()) && inputDate > startDate;
                                },
                                message: (error: any, field: FormlyFieldConfig) =>
                                  `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                              },
                            }
                        },
            {
              "className": 'xl:col-span-1 sm:col-span-1 md:col-span-1',
              "key": 'jd.occupazione_orario',
              "type":'mat-input',
              "props": {
                "label": "FASCIA ORARIA DI OCCUPAZIONE",
                "required": true
              },
            },
            {
                "className": 'xl:col-span-2 sm:col-span-1 md:col-span-3',
                "key": 'jd.occupazione_note',
                "type":'mat-textarea',
                "defaultValue":'',
                "props": {
                  "label": 'ALTRE ANNOTAZIONI/ COMUNICAZIONI',
                  "autosize":true,
                  "autosizeMaxRows":8,
                  "autosizeMinRows": 2
                },
              },
          ],
          validators: {
            validation: [{ name: 'dateRangeValidator', options: { start:'jd.autorizzata_dal', end:'jd.autorizzata_al', errorPath: 'jd.autorizzata_al', message: 'La data di fine deve essere successiva alla data di inizio' } }],
        },
        },

      ],
    }
  ]

